import { serverTimestamp } from "firebase/firestore"
import config from "../config"
import { ContactUsFormModel } from "../models/contact-us"
import { BaseMailFormModel, MailTemplateName, MAIL_TEMPLATES } from "../models/mail"
import { PetSittingRequestFormModel } from "../models/pet-sitting-request"

export const buildMailDocData = <T extends BaseMailFormModel>(
    id: string,
    templateName: MailTemplateName,
    data: T
) => ({
    id,
    to: data.to,
    // The from address must remain our authenticated sender (SPF/DKIM).
    from: config.mail.fromEmail,
    // Replies go directly to the customer.
    replyTo: data.email,
    template: {
        name: templateName,
        data,
    },
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
})

export const buildContactUsMailDocData = (
    id: string,
    data: ContactUsFormModel
) => buildMailDocData(id, MAIL_TEMPLATES.contactUs, data)

export const buildPetSittingRequestMailDocData = (
    id: string,
    data: PetSittingRequestFormModel
) => buildMailDocData(id, MAIL_TEMPLATES.petSittingRequest, data)
